module.exports = __webpack_public_path__ + "img/time.af8ae9ae.svg";